import React from "react";
import { useLocation } from "react-router-dom";
import { useIsFetching } from "@tanstack/react-query";
import "./NavigationProgress.css";

const isPublicRoute = (pathname) =>
  !pathname.startsWith("/dashboard") && !pathname.startsWith("/login");

const isPublicContentQuery = (query) => {
  const rootKey = query.queryKey[0];
  return (
    rootKey === "publicPage" ||
    rootKey === "publicBlogPosts" ||
    rootKey === "publicBlogPost"
  );
};

const NavigationProgress = () => {
  const location = useLocation();
  const fetchingCount = useIsFetching({
    predicate: (query) => isPublicContentQuery(query),
  });

  if (!isPublicRoute(location.pathname) || fetchingCount === 0) {
    return null;
  }

  return (
    <div className="navigation-progress" aria-hidden="true">
      <div className="navigation-progress__bar" />
    </div>
  );
};

export default NavigationProgress;
